import { useSelector } from 'react-redux';
import store from 'src/redux/store';

export default function useIsFeatureFlagEnabled(flag) {
  const featureFlags = useSelector(state => state.usersReducer.user?.featureFlags);
  return featureFlags && featureFlags.includes(flag);
}

export const isFeatureFlagEnabled = flag => {
  const featureFlags = store.getState()?.usersReducer?.user?.featureFlags || [];
  return featureFlags.includes(flag);
};
